import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts';

interface Props { onLogout: () => void; }

const DashboardHeader: React.FC<Props> = ({ onLogout }) => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();

  return (
    <div className={`flex justify-between items-center mb-4 ${isRTL ? 'flex-row-reverse' : ''}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <h1 className="text-xl font-bold">
        <span className="text-secondary">Word Flow Challenge</span>
      </h1>
      <div className={`flex gap-3 items-center ${isRTL ? 'flex-row-reverse' : ''}`}>
        <button onClick={onLogout} className="text-red-500 text-sm hover:underline">
          {t('common.logout')}
        </button>
      </div>
    </div>
  );
};

export default DashboardHeader;
